import { InjectionToken } from "@angular/core";

import { BalancesFacade } from "./balances.facade";

export const BALANCES_FACADE = new InjectionToken<BalancesFacade>('BALANCES_FACADE');